import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
  },
  filters: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  filtersLeft: {
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(1),
  },
  filterBox: {
    display: "flex",
    gap: theme.spacing(1),
  },
  filtersRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  drawerContent: {
    padding: 0,
  },
  formBox: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    "&.MuiAccordionDetails-root": {
      paddingLeft: theme.spacing(4),
    },
  },
  textLabel: {
    color: "#5F6164",
    fontSize: 14,
    fontWeight: 400,
    margin: theme.spacing(0, 0, 0.5),
  },
  actionSection: {
    borderTop: "#BEBFC0 1px solid",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: theme.spacing(2),
  },
  actionButtons: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: "0 !important",
    gap: theme.spacing(1),
  },
  actionButtonsLeft: {
    display: "flex",
    gap: 8,
  },
  accordionItem: {
    boxShadow: "none",
    padding: theme.spacing(0, 3),
    margin: 0,
    borderTop: "#BEBFC0 1px solid",
    "&.MuiAccordion-rounded:first-child": {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    "&.MuiAccordion-root.Mui-expanded": {
      margin: 0,
    },
    "&::before": {
      display: "none",
    },
  },
  innerAccordionItem: {
    padding: 0,
    borderTop: "none",
  },
  accordionSummary: {
    padding: 0,
  },
  innerAccordionSummary: {
    borderTop: "none",
    padding: 0,
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
    overflow: "scroll",
  },
  tableHeadCell: {
    padding: "14px 0",
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  tableHeadCellText: {
    fontWeight: 600,
    background: "#F9FAFA",
    textWrap: "nowrap",
  },
  tableCell: {
    padding: "18px 22px",
    background: "#F9FAFA",
    textWrap: "nowrap",
  },
  tableCellContent: {
    padding: "0 22px",
    borderLeft: "1px solid #E0E0E0",
  },
  tableFooter: {
    borderTop: "1px solid #BEBFC0",
    width: "100%",
    height: 64,
    padding: theme.spacing(1, 0),
    position: "sticky",
    background: "#F9FAFA",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    bottom: 0,
  },
  editButton: {
    margin: "auto 0",
    color: "#0129FA",
    cursor: "pointer",
  },
  "@media (max-width: 840px)": {
    filters: {
      gap: 16,
      alignItems: "normal",
      flexDirection: "column",
    },
    filtersRight: {
      width: "100%",
    },
    contentBox: {
      margin: 0,
    },
  },
}));

export const useShiftPageStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
  },
  topSection: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },
  sectionLeft: {
    display: "flex",
    gap: theme.spacing(1),
  },
  sectionRight: {
    display: "flex",
    gap: theme.spacing(1),
  },
  bottomSection: {
    display: "flex",
    gap: theme.spacing(4),
    padding: theme.spacing(0, 3),
    flexWrap: "wrap",
  },
  statsSection: {
    display: "flex",
    margin: theme.spacing(0, 2),
    gap: theme.spacing(2),
  },
  statsContainer: {
    flexGrow: 1,
    background: "#F9FAFA",
    padding: theme.spacing(2, 3),
    borderRadius: 8,
  },
  titleBox: {
    display: "flex",
    gap: 8,
  },
  statsBox: {
    marginTop: 8,
    display: "flex",
    gap: theme.spacing(4),
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  statsTitle: {},
  tableContainer: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    maxHeight: "calc(100vh - 508px)",
    boxSizing: "border-box",
  },
  tableContainer2: {
    display: "inline-block",
    flex: 1,
    position: "relative",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    border: "none",
    maxHeight: "calc(100vh - 500px)",
    boxSizing: "border-box",
  },
  tableContainer3: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    maxHeight: "calc(100vh - 508px)",
    boxSizing: "border-box",
    borderTopRightRadius: 15,
  },
  fixedHeight: {
    height: 50,
  },
  tableHeadCell: {
    padding: "14px 0",
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  tableCell: {
    background: "#F9FAFA",
    padding: "14px 22px",
    textWrap: "nowrap",
    borderBottom: "1px solid #BEBFC0",
  },
  tableCellContent: {
    padding: "0 22px",
    borderLeft: "1px solid #E0E0E0",
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
  },
  checkboxField: {
    width: 104,
    display: "flex",
    justifyContent: "center",
  },
  editField: {
    width: 104,
  },
  serialNumberFields: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(3),
    width: "100%",
    minWidth: 0,
  },
  serialNumberSelect: {
    flex: 1,
    minWidth: 120,
    maxWidth: 120,
    "& .MuiInputBase-root": {
      width: "100%",
    },
  },
  tableFooter: {
    borderTop: "1px solid #BEBFC0",
    padding: theme.spacing(3),
    position: "sticky",
    background: "#F9FAFA",
    zIndex: 1,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
    bottom: 0,
  },
  footerStatsBox: {
    display: "flex",
    gap: theme.spacing(1),
  },
  greenCell: {
    background: "#A8DABC",
  },
  yellowCell: {
    background: "#F5D87A",
  },
  redCell: {
    "MuiAlert-standardError": {
      background: "#F5AAAA",
    },
  },
  greenAlert: {
    background: "#A8DABC",
  },
  redAlert: {
    background: "#F5AAAA",
  },
  orangeAlert: {
    background: "#F5D87A",
  },
  greenDisabled: {
    background: "#a8dabc86",
  },
  yellowDisabled: {
    background: "#f5d87a7e",
  },
  redDisabled: {
    "MuiAlert-standardError": {
      background: "#f5aaaa7e",
    },
  },
  "@media (max-width: 840px)": {
    topSection: {
      flexDirection: "column",
    },
    statsSection: {
      margin: 0,
      flexDirection: "column",
    },
    contentBox: {
      margin: 0,
    },
    sectionRight: {
      flexDirection: "column",
      alignItems: "flex-end",
    },
  },
}));
